import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Container } from 'components/styled/ui';
import Search from './search';
import Logo from './logo';
import Menu from './menu';
import { strings } from 'config';
import $ from 'jquery';
import { LanguageSwitcher } from 'components/layouts';

class Navbar extends Component {
  state = {
    navState: '',
    isSearchOpen: false,
    isContactOpen: false
  };

  componentWillMount() {
    this.setHomeActive();
  }

  componentDidMount() {
    this.scrollToFix();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  scrollToFix() {
    var nav = $('.nav');
    var banner = $('.banner');

    $(window).on('scroll', function() {
      if ($(window).scrollTop() > banner.outerHeight()) {
        nav.addClass('fixed');
      } else {
        nav.removeClass('fixed');
      }
    });
  }

  setHomeActive() {
    if (window.location.pathname.substr(1) === '') {
      this.setState({
        navState: 'home'
      });
    }
  }

  onRouteChanged() {
    if (window.location.pathname.substr(1) === '') {
      this.setState({
        navState: 'home'
      });
    } else {
      this.setState({
        navState: ''
      });
    }
  }

  isSearchOpenMob = isSearchOpen => {
    this.setState({
      isSearchOpen
    });
  };

  isContactOpen = isContactOpen => {
    this.setState({
      isContactOpen
    });
  };

  render() {
    const { isSearchOpen, isContactOpen } = this.state;
    const menuItems = ['Contact'];

    return (
      <Content className={this.state.navState === 'home' ? 'nav no-bg' : 'nav has-bg'}>
        <Container>
          {/* <div className="logo-search-wrap"> */}
          <Logo />
          <div className="switcher--mob">{/* <LanguageSwitcher />    */}</div>

          <div className="switcher--des">
            <Search
              isContactOpen={isContactOpen}
              isSearchOpenMob={this.isSearchOpenMob}
              placeholder={strings.search.placeholder}
            />
          </div>

          {/* </div> */}
          <div className="nav-menu">
            <LanguageSwitcher />

            <div className="switcher--mob">
              <Search
                isContactOpen={isContactOpen}
                isSearchOpenMob={this.isSearchOpenMob}
                placeholder={strings.search.placeholder}
              />
            </div>

            <div className="switcher--des">{/* <LanguageSwitcher />    */}</div>

            {!isSearchOpen && <Menu isContactOpen={this.isContactOpen} menuItems={menuItems} />}
          </div>
        </Container>
      </Content>
    );
  }
}

export default withRouter(Navbar);

const Content = styled.nav`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  /* background: 0 0; */
  align-items: center;
  padding: 16px 0;
  transition: all 0.3s;

  @media screen and (min-width: 768x) {
    padding: 32px 0;
  }

  &.has-bg,
  &.fixed {
    background-image: linear-gradient(96deg, rgba(1, 107, 194, 1), #00766f, rgba(0, 110, 97, 1));
    position: fixed;
  }

  &.fixed.no-bg {
    top: 0;
    /* padding: 10px 0; */
  }

  > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    @media screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
    }

    .logo {
      margin-right: auto;

      @media screen and (min-width: 768px) {
        margin-right: initial;
      }
    }

    .search {
      flex: 1;
      margin: 0 28px;
      max-width: 659px;
    }
  }

  .nav-menu {
    display: flex;
    align-items: center;
  }

  .switcher {
    background: red;
    &--des {
      display: flex;
      flex: 1;
      @media screen and (max-width: 768px) {
        display: none;
      }
    }
    &--mob {
      @media screen and (min-width: 768px) {
        display: none;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/navbar/navbar.js